/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService, ErrorNotificationService } from './services';
import { CrmError } from './model/error';
import { LogService } from 'src/app/services';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector,private logService :LogService) {}

  handleError(error: Error | HttpErrorResponse):void {
    // your custom error handling logic

    const errorService = this.injector.get(ErrorService);
    const notifier = this.injector.get(ErrorNotificationService);

    let objectError: CrmError;

    if (error instanceof HttpErrorResponse) {
      // Server Error
      objectError = errorService.getServerMessage(error);
    } else {
      // Client Error
      objectError = errorService.getClientMessage(error);
    }

    this.logService.error(error);
    notifier.showError(objectError);
  }
}
